<template>
  <div>
    <h6 style="margin: 0px !important">{{ GECIKENCEKTOPLAM }}</h6>
    <p style="color: #ea5455; margin: 0px !important">{{ PUANGCEK }}</p>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      GECIKENCEKTOPLAM: 0.0,
      PUANGCEK: 0.0,
    };
  },
  methods: {
    gelenData() {
      this.GECIKENCEKTOPLAM = this.currencyFormatter(this.params.data.GECIKENCEKTOPLAM, "₺");
      this.PUANGCEK = this.currencyFormatter(this.params.data.PUANGCEK, " ");
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return 0.0;
      } else {
        var parfloat = parseFloat(currency);
        var sansDec = parfloat.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
